import FindWonderful from '../views/hotManagement/findWonderful'
import RankPage from '../views/hotManagement/rankPage'

import Main from '../views/main'

const hotRouter = {
  path: '/find-wonderful',
  component: Main,
  title: '热点管理',
  icon: 'el-icon-s-flag',
  meta: { keepAlive: true },
  children: [
    {
      path: '/rank-page',
      component: RankPage,
      name: 'rankPage',
      title: '排行页面',
      meta: { title: '排行页面' ,keepAlive:true}
    },
    {
      path: '/find-wonderful',
      component: FindWonderful,
      name: 'findWonderful',
      title: '发现精彩',
      meta: { title: '发现精彩' ,keepAlive:true}
    }
  ]
}
  
 export default hotRouter